import "./subHeader.css";

import styled from "styled-components";
import { NavLink } from "react-router-dom";
import 제품소개 from "../pages/img/subheader/subheader2.jpg";
import i18next from "../config/lang/i18next";

const subHeader = () => (
  <div className="container_header">
    <style>
      {`

 .sub_header{
    background: rgb(66 60 71);
    background: linear-gradient(278deg, rgb(66 60 71) 0%, rgb(77 88 119) 100%);
   
  }

  @media (max-width: 700px) {
    .none, .selected {
      width: 33%;
      
    }
  }
  
`}
    </style>
    <div className="sub_header subheader2" style={{ backgroundImage: `url(${제품소개})`, backgroundSize:"cover" }}>
      <div className="sub_header_txt">
        <h2>Products</h2>
        <hr></hr>
        <h3>GM Medical's Products</h3>
      </div>

      <div className="ul_wrapper fixed">
        <ul className="menu_container clearfix">
          <NavLink
            exact="true"
            className={(navData) => (navData.isActive ? "selected" : "none")}
            to="/software"
          >
            <li>{i18next.t("navbar.2-1")}</li>
          </NavLink>
          <NavLink
            exact="true"
            className={(navData) => (navData.isActive ? "selected" : "none")}
            to="/device"
          >
            <li>{i18next.t("navbar.2-2")}</li>
          </NavLink>
          <NavLink
            exact="true"
            className={(navData) => (navData.isActive ? "selected" : "none")}
            to="/medicine"
          >
            <li>{i18next.t("navbar.2-3")}</li>
          </NavLink>
        </ul>
      </div>
    </div>
  </div>
);

export default subHeader;
